import { render, staticRenderFns } from "./OtsTableNew.vue?vue&type=template&id=82197f34&scoped=true&"
import script from "./OtsTableNew.vue?vue&type=script&lang=js&"
export * from "./OtsTableNew.vue?vue&type=script&lang=js&"
import style0 from "./OtsTableNew.vue?vue&type=style&index=0&id=82197f34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82197f34",
  null
  
)

export default component.exports